export default {
  list: { lazy: () => import('./WalletProduct'), component: 'WalletProductList' },
  edit: { lazy: () => import('./WalletProduct'), component: 'WalletProductEdit' },
  create: { lazy: () => import('./WalletProduct'), component: 'WalletProductCreate' },
}
